<div class="pivot-container">
  <dx-toolbar class="toolbar">
    <dxi-item location="center">
      <div *dxTemplate class="export-excel-btn">
        <dx-button
          icon="export"
          text="Excel Aktar"
          (onClick)="onExporting()"
        ></dx-button>
      </div>
    </dxi-item>

    <dxi-item location="center">
      <div *dxTemplate class="chart-button-group">
        <dx-button
          icon="datausage"
          text="Alan Grafiği"
          [stylingMode]="chartType == 'area' ? 'contained' : 'text'"
          [type]="'success'"
          (onClick)="chartBtnClick('area')"
        ></dx-button>
        <dx-button
          icon="datausage"
          text="Sütun Grafiği"
          [stylingMode]="chartType == 'bar' ? 'contained' : 'text'"
          [type]="'success'"
          (onClick)="chartBtnClick('bar')"
        ></dx-button>
        <dx-button
          icon="datausage"
          text="Çizgi Grafiği"
          [stylingMode]="chartType == 'line' ? 'contained' : 'text'"
          [type]="'success'"
          (onClick)="chartBtnClick('line')"
        ></dx-button>

        <dx-button
          icon="datausage"
          text="Nokta Grafiği"
          [stylingMode]="chartType == 'scatter' ? 'contained' : 'text'"
          [type]="'success'"
          (onClick)="chartBtnClick('scatter')"
        ></dx-button>
        <dx-button
          icon="datausage"
          text="Yığılmış Sütun Grafiği"
          [stylingMode]="chartType == 'stackedbar' ? 'contained' : 'text'"
          [type]="'success'"
          (onClick)="chartBtnClick('stackedbar')"
        ></dx-button>
      </div>
    </dxi-item>
    <dxi-item location="center">
      <div *dxTemplate >
       <dx-button class="pivot-button"
              [text]="'Grid'"
               (click)="pivotGridModeChange.emit(false)"
               [width]="'90px'"
              ></dx-button>
      </div>
    </dxi-item>
  </dx-toolbar>
  <div class="chart-buttons" [style.display]="!!chartType ? 'block' : 'none'">
    <dx-button icon="print" stylingMode="text" (onClick)="printChart()">
    </dx-button>
    <dx-button text="PNG" stylingMode="text" (onClick)="exportChart('png')">
    </dx-button>
    <dx-button text="JPEG" stylingMode="text" (onClick)="exportChart('jpeg')">
    </dx-button>
    <dx-button text="SVG" stylingMode="text" (onClick)="exportChart('svg ')">
    </dx-button>
    <dx-button text="GIF" stylingMode="text" (onClick)="exportChart('gif')">
    </dx-button>
  </div>
  <dx-chart class="chart" [style.display]="!!chartType ? 'block' : 'none'">
    <dxo-common-series-settings [type]="chartType"></dxo-common-series-settings>
    <dxo-size [height]="320"></dxo-size>
    <dxo-adaptive-layout [width]="450"></dxo-adaptive-layout>
    <dxo-tooltip [enabled]="true"></dxo-tooltip>
  </dx-chart>

  <dx-pivot-grid
    class="pivot-grid"
    [allowSorting]="true"
    [allowSortingBySummary]="true"
    [allowFiltering]="true"
    [height]="'100%'"
    [showBorders]="true"
    [dataSource]="dataSourceConfig"
  >
 
    <dxo-field-chooser
      [applyChangesMode]="'instantly'"
      [allowSearch]="true"
      [enabled]="true"
    >
    </dxo-field-chooser>
  </dx-pivot-grid>
</div>
